import { render, staticRenderFns } from "./tags-item.vue?vue&type=template&id=7b77e6ff&"
import script from "./tags-item.vue?vue&type=script&lang=js&"
export * from "./tags-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports